import React from 'react'

const Boost = () => {
    return (
        <div className="boost-container">
            <h1>Boost your links today</h1>
            <button type="button"> Get Started</button>
        </div>
    )
}

export default Boost
